import { toast } from '@hivebrite/design-system/Toast';

import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

import { type UserPostProps } from '../types';

interface GetFeedNewPostParams {
  currentUserId: number;
}

export const getFeedNewPost = ({ currentUserId }: GetFeedNewPostParams) =>
  axios
    .get<{ feed_post: UserPostProps }>(Routes.new_user_post_path(currentUserId))
    .then(({ data }) => data.feed_post)
    .catch(() => {
      toast.error(__('Sorry, an error occurred'));
    });
